import { z } from 'zod';
import type { ArticleListQuery } from '@shared/api';

export const articlePageSize = 10;
export const articleSearchSchema = z.object({
  articleQ: z.string().trim().max(200).optional(),
  articleStatus: z.enum(['Draft', 'Approved']).optional(),
  articleTopicId: z.uuid().optional(),
  articlePage: z.coerce.number().int().min(1).max(100000).optional(),
});
export type ArticleSearch = z.infer<typeof articleSearchSchema>;

export function toArticleQuery(search: ArticleSearch): ArticleListQuery {
  return {
    q: search.articleQ?.trim() || undefined,
    status: search.articleStatus,
    topicId: search.articleTopicId,
    page: search.articlePage ?? 1,
    pageSize: articlePageSize,
  };
}
